import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getGradeFields } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const GradeChoose = ({
  control,
  name,
  onSelectChange,
  disabled,
  placeholder,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [gradeData, setGradeData] = useState([])

  const loadOptions = async () => {
    const data = await getGradeFields()
    setIsLoading(false)
    const grade_id = data?.data?.map(dta => {
      return {
        label: dta?.grade && ucfirst(dta.grade),
        value: dta.id,
        ...dta,
      }
    })

    setGradeData(grade_id)
  }

  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={gradeData}
              // placeholder={placeholder ? placeholder : "Grade"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Grade"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              value={value}
              isDisabled={disabled}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              menuPortalTarget={document.querySelector(".modal")}
            />
          )
        }}
      />
    </div>
  )
}

export default GradeChoose
